
import { isEqual } from 'lodash'
import { getStudentData } from '../api.js'

import settings from '../settings.js'
import notifications from '../notifications.js'

const _vars = {
  currStudentData: undefined,
  currTotalStudents: 0,

  getStudentDataPromise: undefined,
  getStudentDataCallback: undefined,

  currApiPromise: undefined,
  currApiParams: undefined,
}

function _getStudentDataFromServer(apiParams) {
  function _responseCallback(response) {
    _vars.currStudentData = response.data
    if (_vars.getStudentDataCallback) {
      _vars.getStudentDataCallback()
    }
  }

  function _responseError(error) {
    notifications.pushError('Unable to get student data from server.', error)
  }

  if (_vars.currApiPromise === undefined || !isEqual(apiParams, _vars.currApiParams)) {
    _vars.currApiPromise = getStudentData(apiParams)
    _vars.currApiPromise.then(_responseCallback).catch(_responseError)
  }
  return _vars.currApiPromise
}

function _getStudentData(id) {
  if (_vars.currStudentData) {
    return Promise.resolve(_getStudentDataSync(id))
  }
  else {
    _vars.getStudentDataPromise = new Promise((resolve) => {
      _vars.getStudentDataCallback = function () {
        resolve(_getStudentDataSync(id))
      }
    })
    return _vars.getStudentDataPromise
  }
}

function _getStudentDataSync(id) {
  if (id === undefined) {
    return _vars.currStudentData
  }

  return _vars.currStudentData.find(elem => elem.db_id === id)
}

function getNumPerPage() {
  return settings.studentList.numPerPage
}

function getCurrentPage() {
  return settings.studentList.currentPage
}

function setCurrentPage(pageNumber) {
  settings.studentList.currentPage = pageNumber
}

function _init() {
  // do nothing
}

_init()

export default {
  getStudentDataFromServer: _getStudentDataFromServer,
  getStudentData: _getStudentData,
  getStudentDataSync: _getStudentDataSync,
  getNumPerPage: getNumPerPage,
  getCurrentPage: getCurrentPage,
  setCurrentPage: setCurrentPage,
}
